export const APIKEY = `${process.env.REACT_APP_API_KEY}`;
export const AUTHDOMAIN = `${process.env.REACT_APP_AUTH_DOMAIN}`;
export const PROJECTID = `${process.env.REACT_APP_PROJECT_ID}`;
export const STORAGEBUCKET = `${process.env.REACT_APP_STORAGE_BUCKET}`;
export const MESSAGINGSENDERID = `${process.env.REACT_APP_MESSAGING_SENDER_ID}`;
export const APPID = `${process.env.REACT_APP_APP_ID}`;
export const MEASUREMENTID = `${process.env.REACT_APP_MEASUREMENT_ID}`;


